import { Ranking } from '../ranking/Ranking';

/**
 * Class representing a imported ranking.
 * @extends Ranking
 * @abstract
 */
export class ImportedRanking extends Ranking {}
